import React from "react";

const WebInProgress = ({ badge, message, socials }) => {
  return (
    <div className="progress-screen-minimal">
      <div className="progress-content-wrapper">
        {/* NAZIV TURNIRA / BADGE NA VRHU */}
        <div className="minimal-status-badge">{badge || "MNT PODSUSED"}</div>

        {/* GLAVNA PORUKA S NEON SJAJEM */}
        <h1 className="minimal-main-message">
          {message || "VIDIMO SE NA TURNIRU OD 23.6 - 27.6"}
        </h1>

        {/* SUBLINE LINIJA */}
        <div className="minimal-divider"></div>

        {/* PAMETNE DRUŠTVENE MREŽE (Prikazuju se samo ako postoji link) */}
        {socials &&
          (socials.facebook || socials.instagram || socials.tiktok) && (
            <div className="minimal-socials-container">
              <span className="socials-title">VIŠE INFO NA:</span>
              <div className="socials-icons-row">
                {socials.facebook && (
                  <a
                    href={socials.facebook}
                    target="_blank"
                    rel="noreferrer"
                    className="social-icon-link fb"
                  >
                    <i className="fi fi-brands-facebook"></i>
                  </a>
                )}

                {socials.instagram && (
                  <a
                    href={socials.instagram}
                    target="_blank"
                    rel="noreferrer"
                    className="social-icon-link ig"
                  >
                    <i className="fi fi-brands-instagram"></i>
                  </a>
                )}

                {socials.tiktok && (
                  <a
                    href={socials.tiktok}
                    target="_blank"
                    rel="noreferrer"
                    className="social-icon-link tt"
                  >
                    <i className="fi fi-brands-tik-tok"></i>
                  </a>
                )}
              </div>
            </div>
          )}
      </div>
    </div>
  );
};

export default WebInProgress;
